import { OverviewPeriod } from '@trace/types';
import { DurationObjectUnits } from 'luxon';

export const OVERVIEW_DURATION_MAP: Record<OverviewPeriod, string> = {
  daily: 'P14D',
  weekly: 'P84D',
  monthly: 'P365D',
};

export const OVERVIEW_STEP_MAP: Record<OverviewPeriod, keyof DurationObjectUnits> = {
  daily: 'day',
  weekly: 'week',
  monthly: 'month',
};

export const OVERVIEW_DATE_FORMAT = 'yyyy-MM-dd';
